module.exports = __webpack_public_path__ + "img/494-0d6466.png";